// Lbl — shared form-label wrapper (a <label> with a small caption above the
// control; `full` spans both grid columns). Phase 4c/4d: promoted from
// components/campaign/Lbl to this neutral ui/ home and de-duplicated with the
// byte-identical local copies in Channels / Campaigns / ChannelDetail.
export function Lbl({
  label,
  children,
  full = false,
}: {
  label: string;
  children: React.ReactNode;
  full?: boolean;
}) {
  return (
    <label className={full ? "col-span-2 block" : "block"}>
      <span className="mb-1 block text-xs text-muted-foreground">{label}</span>
      {children}
    </label>
  );
}
